import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import DateAdapter from "../../adapters/DateAdapter";


export default class AllAuthorizationsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: [
                {
                    'id': '1',
                    'action_request': {
                        'name': 'Free Order Confirmation Request',
                        'requester': 'michael@dundermifflin.com',
                        'timestamp': "2025-07-04T18:10:08.339Z",
                    },
                    'state': 'Pending',
                    'observations': '',
                    'authorizator': null,
                    'response_timestamp': null,
                },
                {
                    'id': '2',
                    'action_request': {
                        'name': 'Judicial Management Request',
                        'requester': 'oscar@dundermifflin.com',
                        'timestamp': "2026-10-09T14:32:51.120Z",
                        'requested_stage': 'prejudicial_management',
                    },
                    'state': 'Pending',
                    'observations': '',
                    'authorizator': null,
                    'response_timestamp': null,
                }
            ],
            errors: []
        }
    }

    authorizations() {
        return this.content().map(authorization => {
            return {
                id: authorization.id,
                actionRequest: {
                    name: this._adaptActionName(authorization),
                    requester: authorization.action_request.requester,
                    timestamp: DateAdapter.adaptDatetime(authorization.action_request.timestamp),
                },
                state: authorization.state,
                responseTimestamp: this._adaptDateOfApproval(authorization.response_timestamp),
                authorizator: this._adaptAuthorizator(authorization.authorizator),
                observations: authorization.observations
            }
        })
    }

    _adaptDateOfApproval(dateOfApproval) {
        if (dateOfApproval === null) {
            return '-';
        } else {
            return DateAdapter.adaptDatetime(dateOfApproval)
        }
    }

    _adaptAuthorizator(authorizator) {
        if (authorizator === null) {
            return '-';
        }
        return authorizator;
    }

    _adaptActionName(authorization) {
        if (authorization.action_request.name === 'Free Order Confirmation Request') {
            return "Pedido Sin Cargo";
        } else if (authorization.action_request.name === 'Customer Onboarding Logistics Closing Request') {
            return "Alta de Cliente - Logística";
        } else if (authorization.action_request.name === 'Customer Onboarding Commercial Closing Request') {
            return "Alta de Cliente - Comercial";
        } else if (authorization.action_request.name === 'Customer Onboarding Finance Closing Request') {
            return "Alta de Cliente - Finanzas";
        } else if (authorization.action_request.name === 'Customer Onboarding Tax Closing Request') {
            return "Alta de Cliente - Impuestos";
        } else if (authorization.action_request.name === 'Advance Payment Request') {
            return "Pedido Con Pago Anticipado"
        } else if (authorization.action_request.name === 'Delivery Site Onboarding Logistics Closing Request') {
            return "Alta de Punto de Entrega - Logística";
        } else if (authorization.action_request.name === 'Delivery Site Onboarding Tax Closing Request') {
            return "Alta de Punto de Entrega - Impuestos";
        } else if (authorization.action_request.name === 'Allowance Confirmation Request') {
            return "Bonificación";
        } else if (authorization.action_request.name === 'Judicial Management Request') {
            return this._adaptJudicialManagementRequestName(authorization.action_request);
        }
        return "Desconocido";
    }

    _adaptJudicialManagementRequestName(actionRequest) {
        const namesByRequestedStage = {
            prejudicial_management: "Pase a Pre Gestión Judicial",
            judicial_management: "Pase a Gestión Judicial",
        };
        return namesByRequestedStage[actionRequest.requested_stage];
    }
}
